// extracted by mini-css-extract-plugin
export var contentBody = "_cd-9";
export var headerImage = "_cd-2";
export var imageButton = "_cd-7";
export var imageButtonIcon = "_cd-8";
export var imageHeader = "_cd-4";
export var imageHeaderText = "_cd-5";
export var imageOverlay = "_cd-3";
export var imageTitle = "_cd-6";
export var imageWrapper = "_cd-1";
export var taskList = "_cd-a";
export var widget = "_cd-0";